import { render, staticRenderFns } from "./NotificationElement.vue?vue&type=template&id=b86f32f0&scoped=true"
import script from "./NotificationElement.vue?vue&type=script&lang=js"
export * from "./NotificationElement.vue?vue&type=script&lang=js"
import style0 from "./NotificationElement.vue?vue&type=style&index=0&id=b86f32f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86f32f0",
  null
  
)

export default component.exports